export { START_DATE, END_DATE } from 'react-dates/constants';

export const OPTION = Object.freeze({
  DATES: 'dates',
  ROOMS: 'rooms',
  FILTERS: 'filters'
});

export const LABEL = Object.freeze({
  buttonFilterTemplate: 'buttonFilterTemplate',
  buttonRoomsTemplate: 'buttonRoomsTemplate',
  buttonDatesTemplate: 'buttonDatesTemplate',
  // Dates
  startDate: 'startDate',
  endDate: 'endDate',
  dates: 'dates',
  apply: 'apply',
  reset: 'reset',
  headerDates: 'headerDates',
  datesDisclaimer: 'datesDisclaimer',
  // Rooms
  rooms: 'rooms',
  headerRooms: 'headerRooms',
  roomsDescription: 'roomsDescription',
  roomsButtonLabel: 'roomsButtonLabel',
  roomsDisclaimerMobile: 'roomsDisclaimerMobile',
  roomsDisclaimerDesktop: 'roomsDisclaimerDesktop',
  // Filters
  headerFilter: 'headerFilter',
  propertyTypeTitle: 'propertyTypeTitle',
  propertyTypesDescription: 'propertyTypesDescription',
  distanceTitle: 'distanceTitle',
  distanceDescriptionTemplate: 'distanceDescriptionTemplate',
  priceRangeTitle: 'priceRangeTitle',
  priceRangeDescription: 'priceRangeDescription',
  priceRangeNumberFormat: 'priceRangeNumberFormat',
  amenitiesTitle: 'amenitiesTitle',
  amenitiesDescription: 'amenitiesDescription',
  seeMoreLabel: 'seeMoreLabel',
  instantBookTitle: 'instantBookTitle',
  instantBookDescription: 'instantBookDescription',
  clearButtonLabel: 'clearButtonLabel',
  updateButtonLabel: 'updateButtonLabel'
});
